import { useEffect, useState } from "react";
import { Row, Col, Card } from "antd";
import { useParams } from "react-router-dom";
import { useClass } from "../../api/Classes";
import Loading from "../../components/Loading";
import ClassDisplay from "../../components/Class/ClassDisplay";
import ClassRegistration from "../../components/Class/ClassRegistration";

const ClassDetails = () => {
  const [course, setCourse] = useState();
  const { id } = useParams();
  const { data, isLoading } = useClass(id);

  useEffect(() => {
    if (data?.course) setCourse(data.course);
  }, [data]);

  return isLoading ? (
    <Loading />
  ) : course ? (
    <Row gutter={20}>
      <Col sm={24} md={15}>
        <ClassDisplay course={course} />
      </Col>
      <Col sm={24} md={9}>
        <Card style={{ width: "100%" }}>
          <ClassRegistration course={course} />
        </Card>
      </Col>
    </Row>
  ) : (
    <p>No content</p>
  );
};

export default ClassDetails;
